import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { api } from './api-loaders';

@Injectable({
  providedIn: 'root'
})
export class LauncherService {

  constructor(private http: HttpClient) {

  }

  public execute(url: string, method: string, contentType: string, data: any): Observable<any> {
    let apiUrl = api.launcher(url);
    return this.http.request(method, apiUrl, { body: data, headers: { 'content-type': contentType } });
    
  }


}
